import { render } from "./designSubFormPreview.vue?vue&type=template&id=26aa3b10&scoped=true"
import script from "./designSubFormPreview.vue?vue&type=script&lang=js"
export * from "./designSubFormPreview.vue?vue&type=script&lang=js"

import "./designSubFormPreview.vue?vue&type=style&index=0&id=26aa3b10&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-26aa3b10"]])

export default __exports__